import { CaretDownOutlined } from "@ant-design/icons";
import { Button, Card, Pagination, Row, Spin, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../../assets/styles/InterbankPlacement.css";

import ArrowLeft from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import ArrowRight from "@untitled-ui/icons-react/build/esm/ArrowRight";
import DownloadTableButtons from "../../../../components/layouts/enhancement/DownloadTableButtons";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../../../redux/actions";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import TableSearchFilter from "../../component/TableSearchFilter";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../contractbooking.config";

const ContractBookingManageBond = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const pageSize = 10; //number of items per page
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [bondsList, setBondsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableStatus, setTableStatus] = useState("Active");
  const [searchText, setSearchText] = useState("");

  const filteredData =
    tableStatus === "Status"
      ? bondsList
      : bondsList.filter((item) => item.status === tableStatus);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const totalPages = Math.ceil(filteredData.length / pageSize);

  const getBondsListAction = () => {
    // START LOAD
    setIsLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.GetBondContracts,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          console.log(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              id: element?.id,
              key: element?.id,
              contractRefId: element?.contractReferenceId || "-",
              customerId: element?.client?.id || "-",
              date:
                BOM.DateTime(element?.dealInitiationDate, "only-date") || "-",
              maturityDate:
                BOM.DateTime(element?.settlementDate, "only-date") || "-",
              dealValue: element?.amount?.toLocaleString() || "-",
              currency: element?.currency?.code || "-",
              status: element?.status?.text || "-",
            });
          });

          //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
          // setBondsList(tempArray.filter((item) => item.disabled === false));
          setBondsList(tempArray);

          //keep the orginal data to use after gList is modified when change from autorise to disable
          // setOriginalList(tempArray);

          //STOP LOAD
          setIsLoading(false);
        }
      },
      "treasury"
    );
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.GetBondContracts, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              id: element?.id,
              key: element?.id,
              contractRefId: element?.contractReferenceId || "-",
              customerId: element?.client?.id || "-",
              date:
                BOM.DateTime(element?.dealInitiationDate, "only-date") || "-",
              maturityDate:
                BOM.DateTime(element?.settlementDate, "only-date") || "-",
              dealValue: element?.amount?.toLocaleString() || "-",
              currency: element?.currency?.code || "-",
              status: element?.status?.text || "-",
            });
          });

          resolve(tempArray);
        }
      });
    }, "treasury");
  };

  const searchFilter = paginatedData.filter(
    (item) =>
      item?.contractRefId?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.customerId === parseInt(searchText)
  );

  useEffect(() => {
    BOM.HasPermission("READ_BONDCONTRACT") && getBondsListAction();
    BOM.HasPermission("CREATE_BONDCONTRACT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const onSelectItemAction = (objParam, selectedRow) => {
    // If no row or multiple rows selected, reset read and update
    if (objParam.length !== 1) {
      setSelectedRow(null);
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });

      // Re-activate other buttons that should remain (like addBtn)
      BOM.HasPermission("CREATE_BONDCONTRACT") &&
        dispatch({ type: cnt.RIGHT_ADD_BTN });
      return;
    }

    setSelectedRow(selectedRow[0]);

    if (BOM.HasPermission("READ_BONDCONTRACT")) {
      dispatch({ type: cnt.RIGHT_DETAIL_BTN });
    }
    if (
      selectedRow[0]?.status?.toLowerCase() === "pending" &&
      BOM.HasPermission("UPDATE_BONDCONTRACT")
    ) {
      dispatch({ type: cnt.RIGHT_EDIT_BTN });
    }
  };

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-bond-contract", {
        state: selectedRow,
      });
    } else {
      console.log("No valid row selected or invalid add button.");
    }
  }

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-bond-contract", {
        state: selectedRow,
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-bond-contract", {
        state: selectedRow,
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const columns = [
    {
      title: (
        <div className="flex items-center">
          <span>Contract Ref ID</span>
          <CaretDownOutlined style={{ fontSize: "12px", marginLeft: "4px" }} />
        </div>
      ),
      dataIndex: "contractRefId",
      key: "contractRefId",
    },
    {
      title: "Customer ID",
      dataIndex: "customerId",
      key: "customerId",
      width: "20%",
    },
    {
      title: "Deal Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
      key: "maturityDate",
    },
    {
      title: "Deal Value",
      dataIndex: "dealValue",
      key: "dealValue",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let bgColor = "#F9FAFB"; // default bg
        let textColor = "#344054"; // default text
        let border = "1px solid #EAECF0";

        switch (text) {
          case "Active":
            bgColor = "#ECFDF3";
            textColor = "#067647";
            border = "1px solid #ABEFC6";
            break;
          case "Inactive":
            bgColor = "#FEE4E2";
            textColor = "#B42318";
            break;
          case "Closed":
          case "Closed Early":
            bgColor = "#FEF3F2";
            textColor = "#B42318";
            border = "1px solid #FECDCA";
            break;
          case "Matured":
            bgColor = "#EFF8FF";
            textColor = "#175CD3";
            border = "1px solid #B2DDFF";
            break;
          case "Pending":
            bgColor = "#F4F3FF";
            textColor = "#5925DC";
            border = "1px solid #D9D6FE";
            break;
          case "Rejected":
            bgColor = "#FEF3F2";
            textColor = "#B42318";
            border = "1px solid #FECDCA";
            break;
          case "Approved":
            bgColor = "#EEF4FF";
            textColor = "#3538CD";
            border = "1px solid #C7D7FE";
            break;
          case "WithdrawnByApplicant":
            bgColor = "#F0F9FF";
            textColor = "#026AA2";
            border = "1px solid #B9E6FE";
            break;
          case "SubmittedAndPendingApproval":
            bgColor = "#F4F3FF";
            textColor = "#5925DC";
            border = "1px solid #D9D6FE";
            break;
          default:
            break;
        }

        return (
          <Tag
            style={{
              padding: "2px 12px",
              borderRadius: "16px",
              border: border,
              fontSize: "12px",
              fontWeight: 500,
              display: "inline-block",
              backgroundColor: bgColor,
              color: textColor,
              textTransform: "capitalize",
            }}
          >
            {text}
          </Tag>
        );
      },
    },
  ];

  const csvColumns = [
    {
      title: "Contract Ref ID",
      dataIndex: "contractRefId",
      key: "contractRefId",
    },
    {
      title: "Customer ID",
      dataIndex: "customerId",
      key: "customerId",
      width: "20%",
    },
    {
      title: "Deal Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
      key: "maturityDate",
    },
    {
      title: "Deal Value",
      dataIndex: "dealValue",
      key: "dealValue",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  // PAINATION ARROE DISABLING
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  const selectableOptions = [
    { label: "All Status", value: "Status" },
    { label: "Active", value: "Active" },
    { label: "Pending", value: "Pending" },
    { label: "Approved", value: "Approved" },
    { label: "Matured", value: "Matured" },
    { label: "Rejected", value: "Rejected" },
    { label: "Closed", value: "Closed" },
  ];

  const handleSelectOnChange = (value) => {
    setTableStatus(value);
    setCurrentPage(1); // Reset to page 1 on filter change
  };

  const hanleOnChangeSearchInput = (e) => {
    const text = e.target.value;
    setSearchText(text);
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onAdd={handleOnCreate}
      onView={handleOnView}
      onEdit={handleOnEdit}
      pageItems={staticConfig.contractbookingBondBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.manageContractBookingBond}
        createPageTitle={labelConfig.contractBookingBond}
      />

      <Card
        style={{
          // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <div className="p-6 bg-white rounded-lg shadow-sm check-ant-design">
            {/* Top Bar */}
            <Row style={{ marginBottom: 20 }}>
              <TableSearchFilter
                searchPlaceholder="Search by Contract Ref. ID/Customer ID"
                selectOptions={selectableOptions}
                selectValue={tableStatus}
                onSelectChange={handleSelectOnChange}
                onSearchChange={hanleOnChangeSearchInput}
                searchText={searchText}
              />

              <DownloadTableButtons
                downloadData={bondsList}
                columns={columns}
                fileName="Bond Contract List"
                onExportClick={getCsvListData}
              />
            </Row>

            {/* Table */}
            <div className="interbankplacement-table">
              <Table
                rowSelection={{
                  onChange: onSelectItemAction,
                  hideSelectAll: true,
                }}
                columns={csvColumns}
                pagination={false}
                dataSource={searchFilter}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <div
                className="interbankplacement-table-pagination"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  <ArrowLeft />
                  Previous
                </Button>

                <Pagination
                  current={currentPage}
                  total={filteredData.length}
                  pageSize={pageSize}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger={false}
                  itemRender={itemRender}
                  // hideOnSinglePage={true}  // This hides the pagination when there's only one page
                />

                <Button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage >= totalPages}
                >
                  Next
                  <ArrowRight />
                </Button>
              </div>
            </div>
          </div>
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractBookingManageBond);
